'use strict';
var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/is-object.js
// module id = 24
// module chunks = 13